import { AppShell } from "@/components/AppShell";
import { AUSWERTUNGEN_SECTION_SUBTITLES } from "@/lib/auswertungenNav";
import { ProjectCompletionsReport } from "@/pages/auswertungen/ProjectCompletionsReport";

export function ProjectCompletionsPage() {
  return (
    <AppShell
      title="Auswertungen"
      subtitle={AUSWERTUNGEN_SECTION_SUBTITLES["project-completions"]}
    >
      <ProjectCompletionsReport />
    </AppShell>
  );
}
